import { useEffect, useState } from 'react';
import { initWasm } from '@wasm/index';
import Convert from '@pages/Convert/Convert';
import styles from '@/App.module.css';

function LightroomConverter() {
  const [ready, setReady] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    initWasm()
      .then(() => setReady(true))
      .catch((err) => setError(err instanceof Error ? err.message : String(err)));
  }, []);

  if (error) {
    return (
      <div className={styles.initOverlay}>
        <h1 className={styles.initTitle}>Failed to load converter</h1>
        <p className={styles.initText}>{error}</p>
        <p className={styles.initText}>Please refresh the page or try a different browser.</p>
      </div>
    );
  }

  if (!ready) {
    return (
      <div className={styles.initOverlay}>
        <div className={styles.spinner} role="status" aria-label="Initializing converter..." />
        <p className={styles.initText}>Initializing converter...</p>
      </div>
    );
  }

  return <Convert />;
}

export default LightroomConverter;
